class SimilarStylesButton extends HTMLElement {
  constructor() {
    super();

    console.log(document.body.getAttribute('data-preezie-enabled'));
    // Only initialize for Australia (site with Preezie enabled)
    if (document.body.getAttribute('data-preezie-enabled') !== 'true') {

      this.style.cssText = 'display: none !important;';
      
      return;
    }

    this.selectors = {
      preezieWidget: '#prezzie-pdp',
    };

    this.preezieWidget = document.querySelector(this.selectors.preezieWidget);

    this.addEventListener('click', this.onClick.bind(this));
  }

  onClick(event) {
    event.preventDefault();

    if (!this.preezieWidget) return;

    this.preezieWidget.scrollIntoView({behavior: 'smooth', block: 'center'});

    window.sendGreenbackMessage({
      message: 'Show me similar styles',
      trigger: 'pdp',
      source: 'Similar Styles Trigger',
    });
  }
}

// Define custom element
customElements.define('similar-styles-button', SimilarStylesButton);
